module.exports = __webpack_public_path__ + "media/images/mobile/service/patent_bg-501e1ecf33306f62b191409803938955.jpg";